import moment from 'moment'
import React from 'react'
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts'
import WrapperLoader from '../loader/WrapperLoader'
import CustomTooltip from './CustomTooltip'

const EvolutionChart = ({ data, title, subtitle, loading }) => {
  const formatXAxis = (label) => moment(label).format('DD-MMM')

  return (
    <WrapperLoader loading={loading}>
      <div className="dashboard-tile">
        <div className="legend">
          <div className="bold text-capitalize">{title}</div>
          <div>{subtitle}</div>
        </div>
        <div className="evolution-chart">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <XAxis dataKey="date" tick={{ fontSize: 12 }} tickFormatter={formatXAxis} />
              <Tooltip content={<CustomTooltip />} />
              <Line type="monotone" dataKey="count" stroke="#254c8e" strokeWidth="5" dot={false} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </WrapperLoader>
  )
}

export default EvolutionChart
